var map = {
	"./education.csv": [
		663,
		2
	],
	"./education_raw.csv": [
		664,
		3
	],
	"./health.csv": [
		665,
		4
	],
	"./health_raw.csv": [
		666,
		5
	],
	"./population-by-age.csv": [
		246
	],
	"./population-by-ethnicity.csv": [
		667,
		6
	],
	"./population_raw.csv": [
		668,
		7
	],
	"./traffic.csv": [
		669,
		8
	],
	"./traffic_raw.csv": [
		670,
		9
	],
	"./water.csv": [
		671,
		10
	],
	"./water_raw.csv": [
		672,
		11
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 655;
module.exports = webpackAsyncContext;